import type { ReactNode } from "react";
import { Brand } from "../components/Brand";

export function AuthLayout({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-full grid lg:grid-cols-[1.1fr_1fr]">
      <div className="hidden lg:block">
        <Brand />
      </div>
      <div className="flex items-center justify-center p-6 sm:p-10">
        <div className="w-full max-w-sm">
          {/* The photo panel carries the brand on wide screens; on a phone it is
              hidden, so the mark moves here. */}
          <div className="lg:hidden flex items-center gap-3 mb-10">
            <span className="grid place-items-center w-12 h-12 rounded-full bg-accent">
              <img src="/brand/firefly-mark.png" alt="" className="w-[88%] h-[88%] object-contain" />
            </span>
            <span className="text-[1.5rem] font-bold tracking-tight">FireFly</span>
          </div>
          {children}
        </div>
      </div>
    </div>
  );
}
